import Section from "@bmi-digital/components/section";
import { replaceSpaces } from "@bmi-digital/components/utils";
import { graphql } from "gatsby";
import React from "react";
import RichText from "./RichText";
import { classes, GridContainer } from "./styles/TitleWithContentSectionStyles";
import type { TitleWithContentData } from "./TitleWithContent";
import type { PayloadTitleWithContent } from "../types/payload";

export type TitleWithContentSectionData = Pick<
  PayloadTitleWithContent,
  "blockType"
> &
  TitleWithContentData;

type Props = {
  data: TitleWithContentSectionData;
};

const TitleWithContentSection = ({ data }: Props) => {
  return (
    <Section
      backgroundColor="white"
      data-testid={`title-with-content-section-${replaceSpaces(data.title)}`}
    >
      <GridContainer container lg={8} xs={12}>
        {data.title && <Section.Title>{data.title}</Section.Title>}
        <RichText
          document={data.content}
          hasNoBottomMargin
          className={classes.richText}
        />
      </GridContainer>
    </Section>
  );
};

export default TitleWithContentSection;

export const query = graphql`
  fragment TitleWithContentSectionFragment on PayloadTitleWithContent {
    blockType
    ...TitleWithContentFragment
  }
`;
